module.exports = __webpack_public_path__ + "static/media/Second-Eagle.59c22b8e.gif";